/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from "react";

import {
    EnterprisePricingCalculator,
    EnterprisePricingTier,
    isEnterprisePricingTiers
} from "../../utils/enterprise-pricing-calculator";

export function useEnterprisePricingCalculator(
    potentialTiers: unknown,
    minUsers?: number,
    maxUsers?: number
) {
    const tiers: EnterprisePricingTier[] = isEnterprisePricingTiers(
        potentialTiers
    )
        ? potentialTiers
        : [];
    const calculator = useMemo(
        () => new EnterprisePricingCalculator(tiers, minUsers, maxUsers),
        [tiers, minUsers, maxUsers]
    );

    return calculator;
}
